import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../core';
import { IntegrationItem } from './integration-item';
import { IntegrationPeriodicidade, periodicidadeDiaria, isPeriodicidadeDiaria, periodicidadeGeral, isPeriodicidadeGeral } from '../integration-periodicidade';
import { IntegrationItemHttpService } from './services';

@Component({
    selector: 'sgt-integration-item-modal',
    templateUrl: './integration-item-modal.component.html',
    styleUrls: ['./integration-item-modal.component.less']
})
export class IntegrationItemModalComponent implements OnInit {
    entity = new IntegrationItem();
    elModal: any;
    @Output() afterExecuteIntegration = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    periodicidades: IntegrationPeriodicidade[] = [
        periodicidadeDiaria,
        periodicidadeGeral
    ];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integrationItemHttpService: IntegrationItemHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#integrationItemPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.entity.clear();
    }

    open() {
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    private beforeExecute() {
        if (!this.isPeriodicidadeGeral()) {
            this.entity.dataCadastroBase = null;
        }
    }

     /** Executa as integrações de leituras dos itens nos sistemas ERP's manualmente */
    execute() {
        if (this.form.valid) {
            this.beforeExecute();

            const task = new Task('Sincronizando itens com o ERP', 'Executando sincronização dos itens com o sistema ERP');
            this.taskService.add(task, task.description);
            this.integrationItemHttpService.execReadIntegrationManual(this.entity)
                .subscribe(
                    () => {
                        this.taskService.success(task, 'Sincronização dos itens com o sistema ERP realizada com sucesso');
                        this.afterExecuteIntegration.emit();
                    },
                    (error: ApiError) => this.taskService.error(task, 'Erro ao realizar a sincronização dos itens com o sistema ERP', error.message, error)
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para executar a sincronização dos itens com o ERP', 'Informação');
        }
    }

    /** Verifica se a periodicidade selecionada é geral */
    isPeriodicidadeGeral(): boolean {
        if (!this.entity) {
            return false;
        }
        return isPeriodicidadeGeral(this.entity.periodicidade);
    }

    getDescricaoPeriodicidade(periodicidade: number): string {
        if (isPeriodicidadeDiaria(periodicidade)) {
            return 'Diária - Itens cadastrados nas últimas 24 horas';
        } else if (isPeriodicidadeGeral(periodicidade)) {
            return 'Geral - Itens cadastrados a partir de uma data específica'
        }
        return '';
    }
}
